import React from "react";
import { Helmet } from "react-helmet";

import Section from "@coninsa-s2/section";
import Container from "@coninsa-s2/container";
import Breadcrumb, { BreadcrumbItem } from "@coninsa-s2/breadcrumb";
import Heading from "@coninsa-s2/heading";
import TableList from "@coninsa-s2/table-list";

import SearchBar from "../../../../src/search-bar/search";

export function ProsePage({
  headline,
  headlineIcon,
  title,
  body,
  breadcrumbs,
  list,
  icon,
  description,
}) {
  const canonicalUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <>
      {/* SEO con Helmet */}
      <Helmet>
        <title>{title} | Coninsa</title>
        <meta
          name="description"
          content={description || "Encuentra información clara y actualizada en Coninsa sobre trámites, servicios y preguntas frecuentes."}
        />
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      </Helmet>

      {/* Migas de pan */}
      <Section tint="ligther-gray">
        <Container>
          <nav aria-label="breadcrumb" className="mb-8">
            <Breadcrumb>
              {breadcrumbs.map((item, idx) => (
                <BreadcrumbItem key={idx}>
                  {item.url ? <a href={item.url}>{item.label}</a> : item.label}
                </BreadcrumbItem>
              ))}
            </Breadcrumb>
          </nav>
          <SearchBar />
        </Container>
      </Section>

      {/* Contenido principal */}
      <main>
        <Section>
          <Container>
            <div className="grid-cols-12 gap-10 lg:grid">
              <article className="col-span-8 mb-10 lg:mb-0">
                <header className="mb-4 flex items-center gap-4 lg:mb-6">
                  {icon && (
                    <img
                      src={icon}
                      alt="icono ilustrativo"
                      className="h-20 w-20 lg:h-28 lg:w-28"
                    />
                  )}

                  <div>
                    {headline && (
                      <div className="flex items-center gap-4 text-lg text-s2-dark-blue lg:text-[22px]">
                        {headlineIcon && (
                          <img
                            src={headlineIcon}
                            alt="icono encabezado"
                            className="h-12 w-12 lg:h-16 lg:w-16"
                          />
                        )}
                        <h1 className="font-semibold">{headline}</h1>
                      </div>
                    )}

                    {/* Título principal como H1 */}
                    <Heading as="h2" size="2xl" weight="bold">
                      {title}
                    </Heading>
                  </div>
                </header>

                {/* Contenido de la página */}
                <div
                  className="prose"
                  dangerouslySetInnerHTML={{ __html: body }}
                />

                {/* Lista de enlaces adicionales */}
                {list && (
                  <div className="mt-6">
                    <h2 className="mb-4 text-xl font-bold text-s2-gray-700">
                      Más temas relacionados
                    </h2>
                    <TableList className="col-span-8">
                      {list.map((item, idx) => (
                        <li key={idx}>
                          <a href={item.url}>{item.label}</a>
                        </li>
                      ))}
                    </TableList>
                  </div>
                )}
              </article>

              {/* Aside de relacionados */}
              {!list && (
                <aside className="col-span-4">
                  <h2 className="mb-4 text-lg font-bold text-s2-gray-600 lg:text-xl">
                    Relacionados
                  </h2>
                  <TableList>
                    <li>
                      <a href="/servicio-cliente/preguntas-frecuentes/eres-comprador-de-vivienda-nueva/conoce-todo-sobre-tramites-y-creditos-de-proyectos-nuevos/que-se-requiere-para-dar-inicio-al-proceso-de-escrituracion">
                        ¿Qué se requiere para dar inicio al proceso de escrituración?
                      </a>
                    </li>
                    <li>
                      <a href="/servicio-cliente/preguntas-frecuentes/eres-comprador-de-vivienda-nueva/conoce-todo-sobre-tramites-y-creditos-de-proyectos-nuevos/en-que-momento-recibo-copia-de-la-escritura">
                        ¿Después de firmar, en qué momento recibo copia de la escritura?
                      </a>
                    </li>
                    <li>
                      <a href="/servicio-cliente/preguntas-frecuentes/eres-comprador-de-vivienda-nueva/conoce-todo-sobre-tramites-y-creditos-de-proyectos-nuevos/quien-se-encarga-del-proceso-de-legalizacion-del-credito">
                        ¿Quién se encarga del proceso de legalización del crédito?
                      </a>
                    </li>
                  </TableList>
                </aside>
              )}
            </div>
          </Container>
        </Section>
      </main>
    </>
  );
}
